import { routing, type Locale } from './routing'

export const SUPPORTED_LOCALES: Locale[] = [...routing.locales]
